import type { Utility } from '../../../types/utility';
import type { Nav } from './index';

const superNav: Utility.CSSProperties = {
  color: 'blue.60',
  '& > hr': {
    borderStyle: 'solid',
    color: 'blue.60',
  },
};

const chart: Utility.VariantCSSKeys<Nav.Label.VariantKeys> = {
  siteNav: {
    color: 'orange.60',
    '& > hr': {
      borderStyle: 'solid',
      color: 'orange.60',
    },
  },
  superNav,
};

const co: Utility.VariantCSSKeys<Nav.Label.VariantKeys> = {
  siteNav: {
    color: 'blue.60',
    '& > hr': {
      borderStyle: 'solid',
      color: 'blue.60',
    },
  },
  superNav,
};

const shared: Utility.VariantCSSKeys<Nav.Label.VariantKeys> = {
  siteNav: {
    color: 'indigo.60',
    '& > hr': {
      borderStyle: 'solid',
      color: 'indigo.60',
    },
  },
  superNav,
};

const spark: Utility.VariantCSSKeys<Nav.Label.VariantKeys> = {
  siteNav: {
    color: 'red.60',
    '& > hr': {
      borderStyle: 'solid',
      color: 'red.60',
    },
  },
  superNav,
};

const label: Utility.VariantKeyModes<Nav.Label.VariantKeys> = {
  products: {
    chart,
    chartblog: chart,
    co,
    edu: shared,
    scale: shared,
    spark,
  },
};

export const labelVariants = Object.keys(chart) as Nav.Label.VariantKeys[];

export default label;
